import { ReactComponent as NotFoundSvg } from './not-found.svg';
import { ReactComponent as WelcomeSvg } from './welcome.svg';

export const NotFoundIcon = NotFoundSvg;
export const WelcomeIcon = WelcomeSvg;
